import { useParams } from "react-router-dom";
import BookingsPanel from "@/components/BookingsPanel/BookingsPanel";

function CompanyBookingsTab() {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return null;
  }

  return <BookingsPanel companyId={id} />;
}

export default CompanyBookingsTab;
